export function buildDirectoryGraph(operators = [], units = [], meters = []) {
  const norm = (v) => String(v ?? '').trim();

  const operatorCodes = new Set(operators.map((o) => o.OperatorCode));
  const operatorLabelMap = Object.fromEntries(
    operators.map((o) => [o.OperatorCode, o.OperatorName])
  );

  const unitsByOperator = new Map();
  const operatorByUnit = new Map();
  units.forEach((u) => {
    const unitName = norm(u.UnitName);
    operatorByUnit.set(unitName, u.OperatorCode);
    if (!unitsByOperator.has(u.OperatorCode)) unitsByOperator.set(u.OperatorCode, new Set());
    unitsByOperator.get(u.OperatorCode).add(unitName);
  });

  const metersByUnit = new Map();
  const unitByMeter = new Map();
  meters.forEach((m) => {
    const unitName = norm(m.UnitName);
    unitByMeter.set(m.MeterNumber, unitName);
    if (!metersByUnit.has(unitName)) metersByUnit.set(unitName, new Set());
    metersByUnit.get(unitName).add(m.MeterNumber);
  });

  const metersByOperator = new Map();
  const operatorByMeter = new Map();
  meters.forEach((m) => {
    const unitName = norm(m.UnitName);
    const op = operatorByUnit.get(unitName);
    if (!op) return;
    operatorByMeter.set(m.MeterNumber, op);
    if (!metersByOperator.has(op)) metersByOperator.set(op, new Set());
    metersByOperator.get(op).add(m.MeterNumber);
  });

  return {
    operatorCodes,
    operatorLabelMap,
    unitsByOperator,
    operatorByUnit,
    metersByUnit,
    unitByMeter,
    metersByOperator,
    operatorByMeter,
    allUnits: new Set(units.map((u) => norm(u.UnitName))),
    allMeters: new Set(meters.map((m) => m.MeterNumber)),
  };
}
